<template>
  <v-container fluid class="px-10 py-4">
    <template v-slot:after-heading> </template>
    <v-row class="d-flex justify-space-between mx-1 mb-0">
      

      <v-col cols="3" md="3">
        <v-btn @click="goBack" class="primary">
          <i class="mdi mdi-arrow-left-bold"></i>返回
        </v-btn>
        <v-btn @click='pickFile' color="orange" class="mx-3">
          上传文件
          <v-icon right>mdi-upload</v-icon>
        </v-btn>
        <template>
          <input
            type="file"
            style="display: none"
            ref="image"
            accept="*"
            @change="onFilePicked"
          >
</template>
      </v-col>
    </v-row>


    <v-alert
      :value="alert"
      color="red"
      dark
      border="top"
      icon="mdi-bell"
      transition="scale-transition"
    >
      {{ alert_text }}
    </v-alert>
    <v-card class="ma-3 pa-6">
  
    <v-simple-table fixed-header class="mytable">
      <template v-slot:default>
        <thead>
          <tr>
            <th width="50"></th>
            <th width="500" class="text-left">文件名称</th>
            <th width="200"  class="text-center">备注</th>
            <th width="200"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, i) in files_list" :key="i">
            <td class="text-center">
              {{ i + 1 }}
            </td>
            <td class="text-left">
             <a :href="row.fileurl" target="_blank" style="color: #fff;text-decoration: none;">{{ row.filename }} </a> 
             
            </td>
            <td class="text-center">
              {{ row.remark }}
            </td>
            <td class="total_fee">
              <v-btn color="green" icon @click="get_file(row.id)">
                <v-icon left>mdi-file-edit</v-icon>
              </v-btn>
              <v-btn color="red" icon @click="removeFile(row.id)">
                <v-icon left>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-pagination
      v-model="listQuery.page"
      :circle="circle"
      :disabled="disabled"
      :length="total_pages"
      :next-icon="nextIcon"
      :prev-icon="prevIcon"
      :total-visible="totalVisible"
      :value="listQuery.page"
      @input="paginationChangeHandler"
      class="my-3"></v-pagination>
     <div style="text-align: right;width: 100%;margin-bottom: 20px;margin-top: -44px;max-width: 100%;color: gray;">共有{{ total_items }}条记录</div>
    <!-- <div class="text-center">
      <v-row justify="center" align="center">
        <v-pagination
          v-model="listQuery.page"
          :circle="circle"
          :disabled="disabled"
          :length="total_pages"
          :next-icon="nextIcon"
          :prev-icon="prevIcon"
          :total-visible="totalVisible"
          :value="listQuery.page"
          @input="paginationChangeHandler"
        ></v-pagination>
        <span>共{{total_pages}}页</span>
      </v-row>
    </div> -->
    </v-card>

    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ text }}
    </v-snackbar>
    <v-dialog v-model="dialog" max-width="1200">
    
    <v-container class="px-3 my-container" style="background-color: rgba(90, 90, 90, 0.9);">

      <div class="px-7 pb-5" height="800px">
        <v-card-title class="my-10"><h1>编辑文件</h1></v-card-title>
        <v-row>
          <v-text-field
            v-model="file.remark"
            color="yellow darken-3"
            label="备注"
            required
            class="mx-6"
            style="width:120px"
          ></v-text-field>
          
        </v-row>
        
        <v-row>
          <v-spacer></v-spacer>
          <span class="mt-6 mx-3 orange--text" style="font-size:14px">
            本系统由 九色鹿网络 提供技术支持。
          </span>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="cancelEditDialog">取消</v-btn>
          <v-btn color="primary" @click="confirmEditDialog">确认</v-btn>
        </v-card-actions>
      </div>
    </v-container>
  </v-dialog>
  </v-container>
</template>

<script>
import { fetchAreaFiles,fetchFile,updateFile } from "@/api/files";
import { upload,remove } from "@/api/upload";

export default {
  name: "Details",

  components: {
    // AddDeliveryTimeDialog: () => import("./addDeliveryTimeDialog")
  },

  data: () => ({
    snackbar: false,
    text: "",
    timeout: 3000,
    alert: false,
    alert_text: "",
    dialog:false,
    edit: {
        color: "blue",
        icon: "mdi-file-edit"
      },
    action: {
      color: "info",
      icon: "mdi-message-text"
    },
    exportItems: [],
    items: [],
    listQuery: {
      page: 1,
      limit: 10,
      sort: "+id"
    },
    surplus:0,
    search: undefined,
    awaitingSearch: false,
    circle: true,
    disabled: false,
    length: 10,
    nextIcon: "mdi-chevron-right",
    prevIcon: "mdi-chevron-left",
    totalVisible: 10,
    total_pages: 0,
    total_items:0,
    temp: {
      id: "",
      delivery_time: "",
    },
    files_list:[],
    details:{},
    file:""
  }),

  computed: {
    isAdminRole() {
      // console.log("roles: ", this.$store.getters.roles);
      if (this.$store.getters.roles.includes("administrator")) {
        return true;
      } else {
        return false;
      }
    }
  },

  created() {
    this.getList();
  },
  watch: {
   
  },
  methods: {
    pickFile() {
      this.$refs.image.click()
    },
    goBack() {
      console.log("goback clicked");
      this.$router.go(-1);
    },
    getQuery() {
      setTimeout(() => this.getList(), 500);
    },
   
    getList() {
      console.log("xxxx");
      this.listLoading = true;
      this.listQuery.limit = 12;
      this.listQuery.type = 4;
      console.log()
      fetchAreaFiles(this.listQuery).then(response => {
        this.files_list = response.data.items;
        this.total_pages = response.data._meta.total_pages;
        this.total_items = response.data._meta.total_items;
        // Just to simulate the time of the request
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },
    get_file(file_id) {
      this.dialog = true;
      fetchFile(file_id).then(response => {
        this.file = response.data;
        setTimeout(() => {
          this.listLoading = false;
        }, 1.5 * 1000);
      });
    },
    confirmEditDialog() {
      const tempData = this.file;
      console.log(tempData);
      updateFile(this.file.id,tempData).then(() => {
        this.dialog = false;
        this.file = {};
        this.getList()
      });
    },
    cancelEditDialog() {
      this.dialog = false;
      this.file = {};
    },
    onFilePicked(e) {
      var files = e.target.files
      const fd = new FormData()
      fd.append('file',files[0])
      upload({filetype:4},fd).then(() => {
        this.getList()
      });
    },
    removeFile(id) {
      this.$confirm("确认删除当前文件?").then(res => {
        if (res) {
          remove({id:id}).then(response => {
            // console.log('response: ', response)
            if (response.data.error) {
              this.alert_text = response.data.error;
              this.alert = true;
            } else {
              this.getList();
              // Just to simulate the time of the request
              this.text = "当前文件删除成功！";
              this.snackbar = true;
            }
          });
        }
      });
    },
    paginationChangeHandler(pageNumber) {
      this.listQuery.page = pageNumber;
      this.getList();
    },

    reset() {
      this.$refs.form.reset();
    },

    resetValidation() {
      this.$refs.form.resetValidation();
    },
    
  }
};
</script>

<style scoped>

table,
thead,
th {
  color: rgb(11, 105, 247) !important;
  border-bottom: none;
}

table,
thead,
tr {
  color: #fff;
  font-weight: 400;
  border-bottom: none;
  font-weight: 400;
}
th {
  font-size: 13px !important;
  text-align: right !important;
  color: rgb(255, 255, 255);
  font-weight: 400 !important;
}

td {
  font-size: 13px !important;
  text-align: right !important;
  color: rgb(255, 255, 255);
  font-weight: 400;
}

.fee {
  font-weight: 600 !important;
  color: rgb(15, 126, 201);
}

.total_fee {
  color: rgb(253, 113, 113);
  font-weight: 800;
}

tr:hover {
  background-color: #0282b4 !important;
  color: rgb(224, 221, 221);
}

table { border-collapse:collapse } 
table td, table th {
  height: 50px; 
}

.customer_name {
  color:chocolate;
  font-size:24px;
  margin: 10 0 0 0 !important;
}
.dialog-style {
  background-color: rgb(40, 40, 40) !important;
}
</style>
